export default __webpack_public_path__ + "static/media/check-mark.1d191e4c.svg";